import Events from '@utilities/events';
import api from '../../../../../../../app_dept_base/cartridge/client/default/js/utilities/api/api';

const FORM_ITEM_EL = '.form__item';
const HIDDEN_FIELDS_HOOK = '[js-hook-form-fields-toggle-hidden-fields]';
const UPDATE_LINK = '[js-hook-update-free-vat]';
const HIDDEN_CLASS = 'u-hidden';
const FORM_ITEM_DISABLED_CLASS = 'form__item--disabled';

// hooks for custom consent management
const JS_HOOK_CONSUMER = '[js-hook-consumer]';
const JS_HOOK_PROFESSIONAL = '[js-hook-professional]';
const JS_HOOK_PRICE = '[js-hook-price]';
const JS_HOOK_SUB_TOTAL_VAT = '[js-hook-sub-total-vat]';
const JS_HOOK_SUB_GRAND_VAT = '[js-hook-grand-total-vat]';
const JS_HOOK_TEXT_VAT = '[js-hook-text-vat]';
const JS_HOOK_VAT_CODE_INPUT = '[js-hook-vat-code-input]';
const JS_HOOK_VAT_CODE_SUCCESS = '[js-hook-vat-code-success]';

function getContentSuccess(data) {
  const prices = [...document.querySelectorAll(JS_HOOK_PRICE)];
  const subTotal = document.querySelector(JS_HOOK_SUB_TOTAL_VAT);
  const grandTotal = document.querySelector(JS_HOOK_SUB_GRAND_VAT);
  const vatText = document.querySelector(JS_HOOK_TEXT_VAT);
  const vatCodeSuccess = document.querySelector(JS_HOOK_VAT_CODE_SUCCESS);

  prices.forEach(priceDiv => {
    const productID = priceDiv.dataset.pid;
    const newPriceMarkup = data.productPriceArr.find((el) => el.id === productID).price;
    priceDiv.outerHTML = newPriceMarkup;
  })
  subTotal.textContent = data.subTotal;
  grandTotal.textContent = data.grandTotal;
  grandTotal.dataset.cartTotal = data.grandTotalValue;
  vatText.innerHTML = data.vatText;

  if (data.type === 'B2B') {
    vatCodeSuccess.classList.remove('d-none');
  } else {
    vatCodeSuccess.classList.add('d-none');
  }
}

class FormFieldsToggle {
  constructor(element) {
    this.element = element;
    this.radioIds = this.element.dataset.radioIds.split(',');
    this.form = this.element.closest('form');
    this.hiddenFields = [...document.querySelectorAll(HIDDEN_FIELDS_HOOK)];
    this.professional = [...document.querySelectorAll(JS_HOOK_PROFESSIONAL)];
    this.consumer = [...document.querySelectorAll(JS_HOOK_CONSUMER)];

    if (this.hiddenFields.length === 0) return;

    this.updateHiddenFields();
    this.bindEvents();

    FormFieldsToggle.vatCodeCheck();
  }


  updateHiddenFields() {
    if (this.consumer && this.professional){
      this.consumer.forEach(elem => elem.classList.remove(HIDDEN_CLASS));
      this.professional.forEach(elem => elem.classList.add(HIDDEN_CLASS));
    }
    // Hide all hidden fields elements
    this.hiddenFields.forEach(fields => {
      fields.classList.add(HIDDEN_CLASS);

      const inputs = [...fields.querySelectorAll('.input__input')];

      inputs.forEach(input => {
        input.setAttribute('disabled', 'disabled');
        input.setAttribute('data-ignored', '');
        input.closest(FORM_ITEM_EL).classList.add(FORM_ITEM_DISABLED_CLASS);
      })
    })

    // Find checked radio id & match with hidden fields data-id
    // Show correct hidden fields element
    this.radioIds.forEach(id => {
      const radioField = document.getElementById(id);
      const link = document.querySelector(UPDATE_LINK);
      const updateVat = link ? link.dataset.updateVatFrontend : '';
      const data = {};
      if (radioField && radioField.checked) {
        this.hiddenFields.forEach(fields => {
          const fieldsId = fields.dataset.radioId;

          if (fieldsId === id) {
            fields.classList.remove(HIDDEN_CLASS);

            const inputs = [...fields.querySelectorAll('.input__input')];

            if (this.consumer && this.professional) {
              this.consumer.forEach(elem => elem.classList.add(HIDDEN_CLASS));
              this.professional.forEach(elem => elem.classList.remove(HIDDEN_CLASS));
            }

            inputs.forEach(input => {
              input.removeAttribute('disabled');
              input.removeAttribute('data-ignored');
              input.closest(FORM_ITEM_EL).classList.remove(FORM_ITEM_DISABLED_CLASS);
            })
          } else if (link && updateVat === 'true') {
            const { updateLink }  = link.dataset;
            data.type = 'standart'
            api.post(updateLink, data)
            .then((response) => getContentSuccess(response.data))
            .catch((error) => {
              console.log('Fetch update free VAT error: ', error); // eslint-disable-line no-console
            });
          }
        })
      }
    })

    Events.$trigger('form::update-inputs');
  }

  /**
   * Bind all general events
   */
  bindEvents() {
    this.form.addEventListener('change', () => this.updateHiddenFields());
  }

  static vatCodeCheck() {
    const vatCodeInput = document.querySelector(JS_HOOK_VAT_CODE_INPUT);

    if (vatCodeInput) {
      vatCodeInput.addEventListener('blur', () => {
        const linkElement = document.querySelector(UPDATE_LINK);
        const vatCode = vatCodeInput.value;
        let { vatCodeValidation }  = linkElement.dataset;

        vatCodeValidation = `${vatCodeValidation}?vatNumber=${vatCode}`;

        api.get(vatCodeValidation)
          .then((response) => {
            const { updateLink }  = linkElement.dataset;
            const data = response.data.succsses ? {type: 'B2B'} : {type: 'standart'};

            api.post(updateLink, data)
              .then((updateLinkResponse) => getContentSuccess(updateLinkResponse.data))
              .catch((error) => {
                console.log('Fetch update free VAT error: ', error); // eslint-disable-line no-console
              });
          })
          .catch((error) => {
            console.log(error);// eslint-disable-line no-console
          });
      });
    }
  }
}

export default FormFieldsToggle;
